export enum STATUS_ENUM {
    ACTIVE = "active",
    INACTIVE = "inactive",
    DELETED = "delete",
    DRAFT = "draft"
}

export enum BANNER_TYPE {
    TYPE_ONE = "banner_type_one",
    TYPE_TWO = "banner_type_two",
    TYPE_THREE = "banner_type_three",
    TYPE_FOUR = "banner_type_four"
}

export const banner_type_data: { label: string, value: string }[] = [
    {
        label: "แพทเทิร์น 1", // i18n-ignore: translated at render site
        value: BANNER_TYPE.TYPE_ONE
    },
    {
        label: "แพทเทิร์น 2", // i18n-ignore: translated at render site
        value: BANNER_TYPE.TYPE_TWO
    },
    {
        label: "แพทเทิร์น 3", // i18n-ignore: translated at render site
        value: BANNER_TYPE.TYPE_THREE
    },
    {
        label: "แพทเทิร์น 4 (ไม่มีแบนเนอร์)", // i18n-ignore: translated at render site
        value: BANNER_TYPE.TYPE_FOUR
    },
]


export enum CONTENT_TYPE {
    CONTENT = 'CONTENT', //เนื้อหา
    NEWS = 'NEWS',  //ข่าวประชาสัมพันธ์
    ACTIVITY = 'ACTIVITY', //ปฎิทินกิจกรรม
    ADMISSION = 'ADMISSION', //Admission
}


export enum CONTENT_NEWS_ENUM {
    NEW = "new",
    HOT = "hot",
    RECOMMEND = "Recommend"
}

export const content_news_status_data: { label: string, value: string }[] = [
    {
        label: "ข่าวมาแรง", // i18n-ignore: translated at render site
        value: CONTENT_NEWS_ENUM.HOT
    },
    {
        label: "ข่าวใหม่", // i18n-ignore: translated at render site
        value: CONTENT_NEWS_ENUM.NEW
    },
    {
        label: "ข่าวแนะนำ", // i18n-ignore: translated at render site
        value: CONTENT_NEWS_ENUM.RECOMMEND
    },
]